// Trường ngày hiệu lực dùng chung SCR-050 (tách file để fast-refresh chỉ export component).
import type { Dayjs } from "dayjs";

/** Client hint: ngày hiệu lực không được quá khứ (backend vẫn enforce — Spec §12.2/DD-12). */
export function isPastEffectiveDate(current: Dayjs | null, today: Dayjs): boolean {
  return current != null && current.isBefore(today, "day");
}
